export default __webpack_public_path__ + "static/media/PRIMExp.c718ab3d.md";